<div style="text-align:center; margin: 2rem 0;">
  <img src="assets/images/agenda.jpeg" alt="Agenda" style="width: 100%; height: auto; border-radius: 12px; box-shadow: 0 2px 8px rgba(44, 131, 179, 0.08);">
</div>
